<template>
    <div>
        <div id="main-content" class="d-lg-flex main-content">
            <div id="app" class="col-12 p-1 pb-2 px-2 px-lg-3 pb-lg-4">
                <div class="row row-cols-1 p-1 m-1 h-100">

                    <transition name="slide-up">
                        <keep-alive>
                            <Mood :user="user" v-bind:style="{opacity: logoOpacity}" v-if="dynamicComponent == 'Home'"></Mood>
                        </keep-alive>
                    </transition>

                    <transition :name="dynamicComponent !== 'Home' && this.$nav_history[(this.$nav_history.length - 2)] !== 'Home' ? 'slide-up' : ''">
                        <component v-bind:key="dynamicComponent" v-bind:is="dynamicComponent" :mood="mood" :user="user" :parent="$options.name"></component>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Mood from "@/components/Mood";
import Home from "@/components/Home";
import Messages from "@/components/Messages";
import Questionnaires from "@/components/Questionnaires";
import Questionnaire from "@/components/Questionnaire";
import More from "@/components/More";
import Notifications from "@/components/Notifications";
import axios from "axios";
import Password from "@/components/Password";

export default {
    name: 'HomeContainer',
    components: {
        Mood,
        Home,
        Messages,
        Questionnaires,
        Questionnaire,
        More,
        Notifications,
        Password
    },
    props: [
        'user',
        'page'
    ],
    data() {
        return {
            logoOpacity: 1,
            dynamicComponent: 'Home',
            parent: 'Home',
            mood: {
                mood: null,
                mood_window: null
            },
            cachedComponents: ['Home', 'Messages', 'Notifications']
        }
    },
    methods: {
        updateComponent(component) {
            if (this.cachedComponents.includes(component)) {
                const index = this.cachedComponents.indexOf(component);
                this.cachedComponents.splice(index, 1);
                setTimeout(function () {
                    self.cachedComponents = ['Home', 'Messages', 'Notifications'];
                }, 1)
            }
        }
    },
    mounted() {
        let self = this;
        // self.logoOpacity = 1;
        // let origionalPosition = $("#app").offset().top;
        // $(window, '.router').scroll(function () {
        //     let newPosition = ($("#app").offset().top - $(this).scrollTop());
        //     self.logoOpacity = (newPosition / origionalPosition);
        // });
        //
        // $('.router').scroll(function () {
        //     let newPosition = ($("#app").offset().top - $(this).scrollTop());
        //     self.logoOpacity = (newPosition / origionalPosition);
        // });
    },
    created() {
        let self = this;
        setTimeout(function () {
            self.cachedComponents = ['Home', 'Messages', 'Notifications'];
        }, 1)

        // console.log(Notification.permission);

        if (Notification.permission === 'denied' || Notification.permission === 'default') {

            Notification.requestPermission(function (permission) {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    // console.log("Regranted");
                }
            });
        }
    },
    watch: {
        page: function () {
            this.logoOpacity = 1;
            this.setHistory(this.page);
            this.dynamicComponent = this.page;
            $('.router').scrollTop(0);
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue